import { NoLinkedSpeakingSessionsPlaceholder } from './NoLinkedSpeakingSessionsPlaceholder';
import { TabPane } from 'semantic-ui-react';
import { useLinkedSpeakingSessions } from './useLinkedSpeakingSessions';
import { DebouncedLoader } from 'components';
import { SpeakingSessionsTable } from './SpeakingSessionsTable';
import { useLrwSessionAllowedActions } from 'hooks';
import { UnlinkSpeakingSessionModal } from './UnlinkSpeakingSessionModal';

export const LinkedSpeakingSessions = () => {
  const {
    lrwSessionId,
    isLoadingLinkedSpeakingSessions,
    linkedSpeakingSessions,
    unlinkSessionModalOpen,
    setUnlinkingModal,
    unlinkingSpeakingSession,
    closeModal,
  } = useLinkedSpeakingSessions();
  const allowedActions = useLrwSessionAllowedActions();

  const speakingSessions = linkedSpeakingSessions?.length ? (
    <SpeakingSessionsTable
      linkedSpeakingSessions={linkedSpeakingSessions}
      canUnlinkSpeakingSession={allowedActions.canUnlinkSpeakingSession}
      openUnlinkModal={setUnlinkingModal}
    />
  ) : (
    <NoLinkedSpeakingSessionsPlaceholder />
  );

  return (
    <TabPane>
      {!linkedSpeakingSessions || isLoadingLinkedSpeakingSessions ? (
        <DebouncedLoader margin="5rem" />
      ) : (
        speakingSessions
      )}
      <UnlinkSpeakingSessionModal
        modalOpen={unlinkSessionModalOpen}
        speakingSessionId={unlinkingSpeakingSession}
        lrwSessionId={lrwSessionId}
        closeModal={closeModal}
      />
    </TabPane>
  );
};
